import { render, staticRenderFns } from "./CPOptionDropdown.vue?vue&type=template&id=4223ef03&scoped=true&"
import script from "./CPOptionDropdown.vue?vue&type=script&lang=ts&"
export * from "./CPOptionDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./CPOptionDropdown.vue?vue&type=style&index=0&id=4223ef03&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4223ef03",
  null
  
)

export default component.exports